import axios from "axios";
const Api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL:'http://192.168.0.114:8000/api/v1/admin',
  headers: { Authorization: "Bearer" + ` ${localStorage.getItem("token")}` },
});

// Add a response interceptor
Api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response.status == 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default Api;
